<template>
    <!-- Section Hero -->
    <div 
      class="mt-20 h-[80vh] min-h-[864px] max-h-[994px] w-full bg-cover bg-center bg-no-repeat flex items-center justify-start text-white py-30 relative"
      
    >
      <!-- Overlay sombre pour lisibilité du texte -->
      <!-- <div class="absolute inset-0 bg-[#04406E] opacity-60 z-10"></div> -->
  
      <div class="w-full text-center px-6 relative z-20">
        <div class="max-w-4xl mx-auto">
          <!-- Titre principal - Mobile -->
          <div ref="titleRef" class="opacity-0 -translate-y-8">
            <H3Title className="md:hidden text-3xl sm:text-4xl leading-tight mb-6 drop-shadow-lg text-white">
              Plateforme de <span class="font-extrabold text-[#07A766]">Signalement</span><br>
              <span class="font-extrabold">et d'interaction avec la<br>
              Société Civile</span>
            </H3Title>
            
            <!-- Titre principal - Desktop -->
            <H2Title className="hidden md:block text-5xl md:text-6xl lg:text-7xl leading-tight mb-6 drop-shadow-lg text-white">
              Plateforme de <span class="font-extrabold text-[#07A766]">Signalement</span><br>
              <span class="font-extrabold">et d'interaction avec la<br>
              Société Civile</span>
            </H2Title>
          </div>
  
          <!-- Sous-titre -->
          <div ref="subtitleRef" class="opacity-0 translate-y-4">
            <!-- Sous-titre - Mobile -->
            <PContent className="md:hidden mb-10 opacity-90 text-white text-base sm:text-lg">
              Contribuez à la transparence et à la bonne gouvernance<br>
              en signalant les irrégularités
            </PContent>
            
            <!-- Sous-titre - Desktop -->
            <H4Title className="hidden md:block mb-10 opacity-90 text-white">
              Contribuez à la transparence et à la bonne gouvernance<br>
              en signalant les irrégularités
            </H4Title>
          </div>
  
          <div ref="actionsRef" class="w-full flex flex-col md:flex-row justify-center gap-4 opacity-0 scale-95">
            <Button @click="goToFaire" variant="extra-validation" expandWidth>
              Faire un signalement
            </Button>

            <Button @click="goToSuivre" variant="cancel" expandWidth>
              Suivre un signalement
            </Button>
          </div>
        </div>   
      </div>
    </div>
  </template>
  
<script setup lang="ts">
import { gsap } from 'gsap'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { H2Title, H3Title, H4Title, PContent } from '@/components/atoms/text'
import Button from '@/components/atoms/button/Button.vue'

defineOptions({
  name: 'HeroSection'
})

const router = useRouter()
const titleRef = ref<HTMLElement | null>(null)
const subtitleRef = ref<HTMLElement | null>(null)
const actionsRef = ref<HTMLElement | null>(null)

const goToFaire = () => {
  router.push({ name: 'faire-un-signalement' })
}

const goToSuivre = () => {
  router.push({ name: 'suivre-un-signalement' })
}

onMounted(() => {
  const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

  tl.to(titleRef.value, {
    opacity: 1,
    y: 0,
    duration: 1,
    delay: 0.2
  })
  .to(subtitleRef.value, {
    opacity: 1,
    y: 0,
    duration: 0.8
  }, '-=0.6')
  .to(actionsRef.value, {
    opacity: 1,
    scale: 1,
    duration: 0.8,
    ease: 'back.out(1.7)'
  }, '-=0.4')
})
</script>
  
  <style scoped>
  
  /* Ajustement éventuel si tu veux forcer une hauteur minimale */
  /* @media (max-width: 640px) {
    section {
      min-height: 80vh;
    }
  } */
  </style>